<style scoped>
.slide-enter-active {
  transition: 0.25s ease-out;
}
.slide-leave-active {
  transition: 0.2s ease-in;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}

.factor-container {
  display: grid;
  /* Максимум 3 колонки, минимум 120px */
  grid-template-columns: repeat(auto-fill, minmax(min(100%, max(120px, 100%/4)),1fr));
  grid-gap: 1.5em;
}
@media screen and (max-width: 768px) {
  .factor-container {
    display: flex;
    flex-direction: column;
    gap: 1.5em;
  }
}
</style>
<style>
@media screen and (max-width: 1024px) {
  /* Освободить больше места на каждой FactorCard */
  .factors .hero-body {
    padding-right: 0;
    padding-left: 0;
  }
}
/* Убрать overflow на карточках внутри FactorCard */
.factors .hero-body > div {
  max-width: 100%;
  overflow-x: auto;
}
</style>
<template>
  <div class="factors">
    <div class="columns">
      <div class="column is-three-fifths-widescreen is-half">
        <div class="factor-container">
          <div>
            <FactorCard :name="totp.name" :img="totp.img" :configured="totp.configured" @show="showTotp" />
          </div>
          <div>
            <FactorCard :name="sms.name" :img="sms.img" :configured="smsVerified" @show="showSms" />
          </div>
          <div>
            <FactorCard :name="telegram.name" :img="telegram.img" :configured="telegramConfigured" @show="showTelegram" />
          </div>

          <!-- <div v-if="payControl.active">
            <FactorCard :name="t('auth_factors.payControl')" :configured="payControl.configured" :img="payControl.img"
              @show="showPayControl" />
          </div> -->

          <div>
            <FactorCard :name="webauthn.name" :img="webauthn.img" :configured="webauthn.configured"
              @show="showWebauthn" />
          </div>

          <div>
            <FactorCard :name="mobile.name" :img="mobile.img" :configured="mobile.configured"
              @show="showMobAuthenticator" />
          </div>

        </div>
      </div>
      <transition name="slide">
        <div
          class="column is-two-fifths-widescreen is-half"
          v-if="totp.visible || sms.visible || telegram.visible || /* payControl.visible || */ webauthn.visible || mobile.visible">

          <TotpDetails
            v-if="totp.visible"
            :totp="totp.obj"
            @close="showTotp"
            :img="totp.img"
            @update="updateTotp" />

          <SmsDetails
            v-if="sms.visible"
            :sms="sms.obj"
            :phone="user.phone"
            @close="showSms"
            @update="updateSms"
            :img="sms.img" />

          <TelegramDetails
            v-if="telegram.visible"
            :telegram="telegram.obj"
            :telegram_id="telegram.id"
            @close="showTelegram"
            :img="telegram.img"
            @update="updateTelegram" />

          <!-- <PayControlDetails
            v-if="payControl.visible"
            :payControl="payControl.obj"
            @close="showPayControl"
            :img="payControl.img" /> -->

          <WebauthnDetails
            v-if="webauthn.visible"
            @close="showWebauthn"
            :img="webauthn.img"
            :webauthn="webauthn.obj" />

          <MobileAuthenticatorDetails
            v-if="mobile.visible"
            :mobile="mobile.obj"
            @close="showMobAuthenticator"
            @update="updateMobile"
            :img="mobile.img" />
        </div>

      </transition>
    </div>
  </div>
</template>
<script>
import profile from "@/services/profile";
import tg from "@/services/tg";
import totp from "@/services/totp";
import mobile from "@/services/mobile";
import webauthn from "@/services/webauthn";
import SmsDetails from "@/views/AuthFactors/SmsDetails";
import TotpDetails from "@/views/AuthFactors/TotpDetails";
import TelegramDetails from "@/views/AuthFactors/TelegramDetails";
import FactorCard from "@/views/AuthFactors/FactorCard";
import MobileAuthenticatorDetails from "./MobileAuthenticatorDetails";
import WebauthnDetails from "@/views/AuthFactors/WebauthnDetails";
import { appSettings } from "@/app.settings";

export default {
  name: "AuthFactorList",
  components: {
    MobileAuthenticatorDetails,
    SmsDetails,
    TotpDetails,
    TelegramDetails,
    FactorCard,
    WebauthnDetails
  },
  data() {
    return {
      user: undefined,
      mobile: {
        obj: null,
        active: false,
        visible: false,
        name: "Authenticator",
        img: require("@/assets/mobile.png"),
        configured: false
      },
      totp: {
        obj: null,
        active: true,
        visible: false,
        name: "TOTP",
        img: require("@/assets/totp.png"),
        configured: false
      },
      sms: {
        obj: null,
        visible: false,
        active: true,
        name: "SMS OTP",
        img: require("@/assets/sms.png")
      },
      telegram: {
        obj: null,
        visible: false,
        active: true,
        name: "Telegram OTP",
        img: require("@/assets/telegram.png"),
        id: undefined
      },
      // payControl: {
      //   obj: {},
      //   visible: false,
      //   active: false,
      //   name: "PayControl",
      //   configured: false,
      //   img: require("@/assets/paycontrol.png")
      // },
      webauthn: {
        obj: [],
        visible: false,
        active: false,
        name: "WebAuthn",
        configured: false,
        img: require("@/assets/webauthn.png")
      }
    };
  },
  created() {
    this.fetchUser();
    totp.getKey().then(
      resp => {
        this.totp.obj = resp.data;
        this.totp.configured = resp.data.verified;
      },
      err => {
        console.log(err);
      }
    );

    const params = { sid: this.$store.getters.session_id, client_id: appSettings.clientId, };
    mobile.getBinding(params).then((response) => {
      if (response.status == 200) {
        this.mobile.configured = true;
      }
    });

    tg.getLink().then(
      resp => {
        this.telegram.obj = resp.data;
      },
      err => {
        console.log(err);
      }
    );

    // paycontrol.getState().then(
    //   resp => {
    //     if (
    //       !!resp.data &&
    //       (resp.data.configured == "true" || resp.data.configured === true)
    //     ) {
    //       this.payControl.configured = true;
    //     }
    //     if (
    //       !!resp.data &&
    //       (resp.data.active == "true" || resp.data.active === true)
    //     ) {
    //       this.payControl.active = true;
    //     }
    //   },
    //   err => {
    //     console.log(err);
    //   }
    // );

    this.updateTelegram();

    webauthn.getAuthenticators().then(
      resp => {
        this.webauthn.obj = resp.data;
        if (resp && resp.data) {
          if (resp.data.some((e) => !e.blocked)) {
            this.webauthn.configured = true
            console.log("webauthn active")
          } else {
            console.log("webauthn is not active")
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  },
  methods: {
    t(key) {
      return this.$i18n.t(key);
    },
    setTelegramId(id) {
      this.telegram.id = id
    },
    updateTelegram() {
      tg.getContact().then(
        resp => {
          if (!resp || !resp.data || !Object.keys(resp.data).find(key => key == 'telegramId')) {
            this.telegram.id = 0;
            return;
          }
          this.telegram.id = resp.data.telegramId;
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchUser() {
      profile.fetch().then(
        resp => {
          if (!resp || !resp.data) {
            throw new Error("malformed response");
          }
          this.user = resp.data;
          this.sms.obj = {
            phone: resp.data.phone,
            verified: resp.data.phoneVerified
          };
        },
        err => {
          console.log(err);
        }
      );
    },
    showMobAuthenticator() {
      this.totp.visible = false;
      this.sms.visible = false;
      this.telegram.visible = false;
      // this.payControl.visible = false;
      this.webauthn.visible = false;
      this.mobile.visible = !this.mobile.visible;
    },
    showTotp() {
      this.sms.visible = false;
      this.telegram.visible = false;
      // this.payControl.visible = false;
      this.webauthn.visible = false;
      this.mobile.visible = false;
      this.totp.visible = !this.totp.visible;
    },
    showSms() {
      this.totp.visible = false;
      this.telegram.visible = false;
      // this.payControl.visible = false;
      this.webauthn.visible = false;
      this.mobile.visible = false;
      this.sms.visible = !this.sms.visible;
    },
    showTelegram() {
      this.totp.visible = false;
      this.sms.visible = false;
      // this.payControl.visible = false;
      this.webauthn.visible = false;
      this.mobile.visible = false;
      this.telegram.visible = !this.telegram.visible;
    },
    showPayControl() {
      this.totp.visible = false;
      this.sms.visible = false;
      this.telegram.visible = false;
      this.webauthn.visible = false;
      this.mobile.visible = false;
      // this.payControl.visible = !this.payControl.visible;
    },
    updateTotp(totp, configured) {
      this.totp.obj = totp;
      this.totp.configured = configured;
    },
    updateMobile(configured) {
      this.mobile.configured = configured;
    },
    updateSms(verified) {
      if (this.sms.obj) {
        this.sms.obj.verified = verified;
      }
    },
    showWebauthn() {
      this.totp.visible = false;
      this.sms.visible = false;
      this.telegram.visible = false;
      // this.payControl.visible = false;
      this.mobile.visible = false;
      this.webauthn.visible = !this.webauthn.visible;
    }
  },
  computed: {
    smsVerified() {
      return this.sms && this.sms.obj && this.sms.obj.verified
    },
    telegramConfigured() {
      return (
        this.telegram && !!this.telegram.id
      );
    }
  }
};
</script>
